import { BaseResponseAttributes } from "../attributes/base-attributes";
import BaseService from "./BaseService";
import { RestApiResponse } from "./RestApi";

export class OperatorService extends BaseService {
  static async getAllOperators(): Promise<RestApiResponse<BaseResponseAttributes>> {
    return OperatorService.getApiClient().get(
      `admin/operators`
    );
  }
  
}
export default OperatorService;
